import { VStack, HStack } from "@gluestack-ui/themed";
import { AddressAccordionProps } from "@repo/core/components/layout/ProposalAccordion/variants/AddressAccordion/types";
import { InfoSection } from "@repo/core/components/layout/ProposalAccordion/components/InfoSection";
import { AccordionContainer } from "@repo/core/components/layout/ProposalAccordion/components/AccordionContainer";
import { applyMaskToValue } from "@repo/core/utils/mask.utils";
import { getResidenceTypeLabel } from "./utils";

export const AddressAccordion = ({
  zipCode,
  addressLine1,
  number,
  addressLine2,
  neighborhood,
  city,
  state,
  residenceType,
  ...rest
}: AddressAccordionProps) => {
  const residenceTypeLabel = getResidenceTypeLabel(residenceType);

  return (
    <AccordionContainer {...rest}>
      {residenceTypeLabel ? (
        <VStack flex={1} gap="$4">
          <InfoSection title="Tipo de Residência" value={residenceTypeLabel} />
        </VStack>
      ) : null}
      <InfoSection title="CEP" value={applyMaskToValue(zipCode, "cep")} />
      <InfoSection title="Endereço" value={addressLine1} />

      <HStack flex={1} gap="$4">
        <VStack flex={1} gap="$4">
          <InfoSection title="Número" value={number} />
        </VStack>
        <VStack flex={1} gap="$4">
          <InfoSection title="Complemento" value={addressLine2 || "-"} />
        </VStack>
      </HStack>

      <InfoSection title="Bairro" value={neighborhood} />

      <HStack flex={1} gap="$4">
        <VStack flex={1} gap="$4">
          <InfoSection title="Cidade" value={city} />
        </VStack>
        <VStack flex={1} gap="$4">
          <InfoSection title="UF" value={state} />
        </VStack>
      </HStack>
    </AccordionContainer>
  );
};
